<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-divider orientation="left">{{ $t('报修信息') }}</a-divider>
              <detail-list>
                <detail-list-item :term="$t('报修人名称')">{{model.repairName}}</detail-list-item>
                <detail-list-item :term="$t('报修人电话')">{{model.repairPhone}}</detail-list-item>
                <detail-list-item :term="$t('报修户地址')">{{model.repairAddress}}</detail-list-item>
                <detail-list-item :term="$t('报修时间')">{{model.repairTime}}</detail-list-item>
                <detail-list-item :term="$t('报修描述')" :itemCol="1">{{model.repairDescription}}</detail-list-item>
              </detail-list>
              <div style="color: #999;">
                {{ $t('报修图片:') }}
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="picture" :disabled="true"></j-image-upload>
              </div>
            </a-col>
          </a-row>
          <template v-if="model.isAgree == 1 || model.isAgree == 0">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-divider orientation="left">{{ $t('处理信息') }}</a-divider>
                <a-form-model-item :label="$t('是否开启工单')" prop="isAgree">
                  <a-radio-group v-model="model.isAgree">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24" v-if="model.isAgree == 0">
                <a-form-model-item :label="$t('回复内容')" prop="response">
                  <a-textarea v-model="model.response" :placeholder="$t('请输入回复内容')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <template v-if="model.isAgree == 1">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-divider orientation="left">{{ $t('工单信息') }}</a-divider>
                  <detail-list v-if="model.ticketsNum">
                    <detail-list-item :term="$t('工单编号')" :itemCol="1">{{model.ticketsNum}}</detail-list-item>
                  </detail-list>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单类型')" prop="response">
                    <a-select v-model="model.ticketsType" :placeholder="$t('请选择工单类型')">
                      <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                      <a-select-option :value="1">{{ $t('工程报装') }}</a-select-option>
                      <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单联系人')" prop="response">
                    <el-input type="text" size="small" v-model.trim="model.ticketsContact" :placeholder="$t('请输入工单联系人')" maxlength="20" show-word-limit />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('联系电话')" prop="ticketsContactPhone">
                    <a-input v-model="model.ticketsContactPhone" :placeholder="$t('请输入联系电话')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                    <a-select v-model="model.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')">
                      <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                      <a-select-option :value="1">{{ $t('紧急') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('地理信息')" prop="ticketsLocation">
                    <a-input v-model="model.ticketsLocation" :placeholder="$t('请输入工单位置')"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('截止时间')" prop="ticketsDeadline">
                    <a-date-picker show-time v-model="model.ticketsDeadline" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import {PhoneNumberPattern} from '@/utils/regPattern'
import { mode } from 'mathjs'
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      DetailList,
      DetailListItem,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {
          tickets:{
            ticketsType: 2
          }
        },
        url: {
          queryById: "/jeecg-engineering/wechatapply/wechatMeterRepair/queryById",
          edit: "/jeecg-engineering/wechatapply/wechatMeterRepair/edit",
        },
        picture:''
      }
    },
    computed: {
      validatorRules() {
        return {
          ticketsContact: [{required:true,message:this.$t('请输入工单联系人'),trigger:'blur'}],
          ticketsContactPhone: [{required:true,message:this.$t('请输入联系电话'),trigger:'blur'},{pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}],
          ticketsEmergency: [{required:true,message:this.$t('请选择紧急程度'),trigger:'change'}],
        }
      },
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('详情');
        this.disableSubmit = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.model.ticketsType = 2;
        this.$nextTick(()=>{
          // var arr = JSON.parse(this.model.repairPicture);
          this.$set(this,'picture',this.model.repairPicture);
        });
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model = Object.assign({},this.model,{
              ticketsType: res.result.tickets.ticketsType,
              ticketsContact: res.result.tickets.ticketsContact,
              ticketsEmergency: res.result.tickets.ticketsEmergency,
              ticketsContactPhone: res.result.tickets.ticketsContactPhone,
              ticketsLocation: res.result.tickets.ticketsLocation,
              ticketsDeadline: res.result.tickets.ticketsDeadline,
            })
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>